import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "d2-icon-pass-circle",
  "use": "d2-icon-pass-circle-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" class=\"design-iconfont\" id=\"d2-icon-pass-circle\">\n  <path fill=\"#52C41A\" d=\"M9 2A7 7 0 1 0 9 16A7 7 0 1 0 9 2Z\" />\n  <path d=\"M6 9.27273L8.32236 11.8364C8.40175 11.924 8.53943 11.924 8.61881 11.8364L13 7\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol